import React from 'react';
import {FormattedMessage} from 'react-intl';

import Aux from '../hoc/auxi';

const editForm = (props) => {
    const gender = (<div className="form-group">
        <label htmlFor="gender"><FormattedMessage id="gender"/></label>
        <select className="form-control" id="gender" onChange={props.genderChange} value={props.genderNumber}>
            <option value="null"><FormattedMessage id="no-answer"/></option>
            {props.genderOptions}
        </select>
    </div>);

    let
        department = (<div className="form-group">
            <label htmlFor="department"><FormattedMessage id="department"/></label>
            <select className="form-control" id="department" onChange={props.departmentChange}
                    value={props.departmentNumber}>
                <option value="null"><FormattedMessage id="no-answer"/></option>
                {props.departmentOptions}
            </select>
        </div>)


    let age = (<div className="form-group">
        <label htmlFor="age"><FormattedMessage id="age"/></label>
        <select className="form-control" id="age" onChange={props.ageChange} value={props.ageNumber}>
            <option value="null"><FormattedMessage id="no-answer"/></option>
            {props.ageOptions}
        </select>
    </div>)


    let marital_status = (<div className="form-group">
        <label htmlFor="marital"><FormattedMessage id="marital-status"/></label>
        <select className="form-control" id="marital" onChange={props.maritalChange} value={props.maritalNumber}>
            <option value="null"><FormattedMessage id="no-answer"/></option>
            {props.maritalOptions}
        </select>
    </div>)


    let academic_levels = (<div className="form-group">
        <label htmlFor="academic"><FormattedMessage id="academic"/></label>
        <select className="form-control" id="academic" onChange={props.academicChange} value={props.maritalNumber}>
            <option value="null"><FormattedMessage id="no-answer"/></option>
            {props.academicOptions}
        </select>
    </div>)


    let smoking_status = (
        <Aux>
            <div className="form-group">
                <label htmlFor="smoker_status"><FormattedMessage id="smoker-status-edit"/></label>
                <select className="form-control" id="smoker_status" onChange={props.smokerStatusChange}
                        value={props.smokerStatusNumber}>
                    <option value="null"><FormattedMessage id="no-answer"/></option>
                    {props.smokerStatusOptions}
                </select>
            </div>
        </Aux>
    )


    let regularity_number = null;
    if (props.smoking_status === 'Fumador' || props.smoking_status === 'Smoker') {
        regularity_number = (
            <Aux>
                <div className="form-group">
                    <label htmlFor="regularity"><FormattedMessage id="regularity-edit"/></label>
                    <select className="form-control" id="regularity-edit" onChange={props.smokerRegularityChange}
                            value={props.regularityNumber}>
                        <option value="null"><FormattedMessage id="no-answer"/></option>
                        {props.regularityOptions}
                    </select>
                </div>
                <div className="form-group">
                    <label htmlFor="average_number"><FormattedMessage id="average-number-edit"/></label>
                    <select className="form-control" id="average_number" onChange={props.smokerNumberChange}
                            value={props.weeklyNumberS}>
                        <option value="null"><FormattedMessage id="no-answer"/></option>
                        {props.weeklyNumberOptions}
                    </select>
                </div>
            </Aux>
        )
    }
    ;


    if (props.selectedStatus === "1") {
        regularity_number = (
            <Aux>
                <div className="form-group">
                    <label htmlFor="regularity"><FormattedMessage id="regularity-edit"/></label>
                    <select className="form-control" id="regularity-edit" onChange={props.smokerRegularityChange}
                            value={props.regularityNumber}>
                        <option value="null"><FormattedMessage id="no-answer"/></option>
                        {props.regularityOptions}
                    </select>
                </div>
                <div className="form-group">
                    <label htmlFor="average_number"><FormattedMessage id="average-number-edit"/></label>
                    <select className="form-control" id="average_number" onChange={props.smokerNumberChange}
                            value={props.weeklyNumberS}>
                        <option value="null"><FormattedMessage id="no-answer"/></option>
                        {props.weeklyNumberOptions}
                    </select>
                </div>
            </Aux>
        )
    }

    let health_opinion = (<div className="form-group">
        <label htmlFor="health_opinion"><FormattedMessage id="health-opinion"/></label>
        <select className="form-control" id="health_opinion" onChange={props.healthOpinionsChange}
                value={props.health_opinion_number}>
            <option value="null"><FormattedMessage id="no-answer"/></option>
            {props.healthOpinionOptions}
        </select>
    </div>)


    let weight = (
        <div className="form-group">
            <label htmlFor="number"><FormattedMessage id="weight"/></label>
            <input type="number" min="40" step="0.5" onChange={props.weightChange} value={props.weightNumber}/>
        </div>
    )


    let height = (
        <div className="form-group">
            <label htmlFor="number"><FormattedMessage id="height"/></label>
            <input type="number" min="1" step="0.01" onChange={props.heightChange} value={props.heightNumber}/>
        </div>
    )


    let has_chronic= (<div className="form-group">
        <p style={{marginBottom: "-2px", fontWeight: "bold"}}>É portador de alguma doença crónica?</p>
    <div className="form-check form-check-inline">
        <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1"
               value="1" defaultChecked={props.has_chronic === 1 }
               onChange={props.chronicChange}/>
        <label className="form-check-label" htmlFor="inlineRadio1">Sim</label>
        </div>
        <div className="form-check form-check-inline">
        <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2"
        value="0" defaultChecked={props.has_chronic === 0}
        onChange={props.chronicChange}/>
        <label className="form-check-label" htmlFor="inlineRadio2">Não</label>
        </div>
    </div>
    )

    let chronic = '';

  /*  if (props.chronicValue === '1') {

        chronic = <div className="form-group">Indique quais:
            {props.chronicOSelect}</div>
        ;
    } */ if ( props.has_chronic === 1 && props.chronic_diseases == null ) {

        chronic = <div className="form-group">Indique quais:
            {props.chronicOSelect}</div>
        ;
    }



    let chronicValues = null;
    if (props.chronicValue === "1" || props.has_chronic === 1) {
        chronicValues = (/*<div className="form-group">
            <label htmlFor="chronic_values"><FormattedMessage id="chronic-diseases-edit"/></label>
            <select className="form-control" id="chronic_values" onChange={props.chronicValuesChange}
                    value={props.chronic_diseases_number}>
                <option value="null"><FormattedMessage id="no-answer"/></option>
                {props.chronicValuesOptions}
            </select>
        </div>*/
            <div className="form-group">Indique quais:
                {props.chronicOSelect}</div>)
        if(props.chronicValue === "0") {
            chronicValues = null;
        }
    }
    ;

    /*if (props.selectedHasChronic === "1") {
        chronicValues = (
            (<div className="form-group">
                <label htmlFor="chronic_values"><FormattedMessage id="chronic-diseases-edit"/></label>
                <select className="form-control" id="chronic_values" onChange={props.chronicValuesChange}
                        value={props.chronic_diseases_number}>
                    <option value="null"><FormattedMessage id="no-answer"/></option>
                    {props.chronicValuesOptions}
                </select>
            </div>)
        )
    }
    ;
*/
    let takes_meds = (<div className="form-group">
        <p style={{marginBottom: "-2px", fontWeight: "bold"}}>Toma regularmente algum fármaco?</p>
        <div className="form-check form-check-inline">
            <input className="form-check-input" type="radio" name="inlineRadioOptions1" id="inlineRadio3"
                   value="1" defaultChecked={props.takes_meds === 1 }
                   onChange={props.medChange}/>
            <label className="form-check-label" htmlFor="inlineRadio3">Sim</label>
        </div>
        <div className="form-check form-check-inline">
            <input className="form-check-input" type="radio" name="inlineRadioOptions1" id="inlineRadio4"
                   value="0" defaultChecked={props.takes_meds === 0}
                   onChange={props.medChange}/>
            <label className="form-check-label" htmlFor="inlineRadio4">Não</label>
        </div>
    </div>);

    let meds_number_values = null;
    if ((props.takesMedsNumber == 1)) {
        meds_number_values = (
            <Aux>
                <div className="form-group">
                    <label htmlFor="number" ><FormattedMessage id="meds-number-edit"/></label>
                    <input type="number" step="1" min="0" className="form-control" onChange={props.medsNumberChange} value={props.medsNumberS}/>
                </div>
                <div className="form-group">Indique quais:
                    {props.medsSelect}</div>
            </Aux>
        )
        if(props.medValue === "0") {
            meds_number_values = null;
        }
    }
    ;


    /*if (props.selectedTakesMeds === "1") {
        meds_number_values = (
            <Aux>
                <div className="form-group">
                    <label htmlFor="number"><FormattedMessage id="meds-number-edit"/></label>
                    <input type="number" step="1" min="0" onChange={props.medsNumberChange} value={props.medsNumberS}/>
                </div>
                <div className="form-group">
                    <label htmlFor="meds_values"><FormattedMessage id="meds-name-edit"/></label>
                    <select className="form-control" id="meds_values" onChange={props.medsValuesChange}
                            value={props.medsValuesNumber}>
                        <option value="null"><FormattedMessage id="no-answer"/></option>
                        {props.medsValuesOptions}
                    </select>
                </div>
            </Aux>
        )
    }
    ;*/

    let pain_value = (<div className="form-group">
        <label htmlFor="pain"><FormattedMessage id="pain"/></label>
        <select className="form-control" id="pain" onChange={props.painValueChange} selected={props.selectedPainValue}
                value={props.painValueNumber}>
            <option value="null"><FormattedMessage id="no-answer"/></option>
            {props.painValueOptions}
        </select>
    </div>)

    let pain_local_scale = null;

    if (props.painValueNumber == 2 || props.painValueNumber == 3) {
        pain_local_scale = (
            <Aux>
                <div className="form-group">
                    <label htmlFor="local_pain"><FormattedMessage id="pain-local"/></label>
                    <select className="form-control" id="local_pain" onChange={props.localPainChange}
                            value={props.localPainNumber}>
                        <option value="null"><FormattedMessage id="no-answer"/></option>
                        {props.localPainOptions}
                    </select>
                </div>
                <div className="form-group">
                    <label htmlFor="pain_scale"><FormattedMessage id="pain-scale"/></label>
                    <select className="form-control" id="pain_scale" onChange={props.painScaleChange}
                            value={props.painScaleNumber}>
                        <option value="null"><FormattedMessage id="no-answer"/></option>
                        {props.painScaleOptions}
                    </select>
                </div>
            </Aux>
        )
    }
    ;

    let meals = (<div className="form-group">
        <label htmlFor="meals"><FormattedMessage id="meals"/></label>
        <select className="form-control" id="meals" onChange={props.mealsChange} value={props.mealsNumber}>
            <option value="null"><FormattedMessage id="no-answer"/></option>
            {props.mealsOptions}
        </select>
    </div>)


    let breakfast = (<div className="form-group">
        <label htmlFor="breakfast"><FormattedMessage id="breakfast"/></label>
        <select className="form-control" id="breakfast" onChange={props.breakfastChange} value={props.breakfastNumber}>
            <option value="null"><FormattedMessage id="no-answer"/></option>
            {props.breakfastOptions}
        </select>
    </div>)


    let fruit = (<div className="form-group">
        <label htmlFor="fruit"><FormattedMessage id="fruit"/></label>
        <select className="form-control" id="fruit" onChange={props.fruitChange} value={props.fruitNumber}>
            <option value="null"><FormattedMessage id="no-answer"/></option>
            {props.fruitOptions}
        </select>
    </div>)


    let vegetables = (<div className="form-group">
        <label htmlFor="vegetables"><FormattedMessage id="vegetables"/></label>
        <select className="form-control" id="vegetables" onChange={props.vegetablesChange}
                value={props.vegetablesNumber}>
            <option value="null"><FormattedMessage id="no-answer"/></option>
            {props.vegetablesOptions}
        </select>
    </div>)


    let sodas = (<div className="form-group">
        <label htmlFor="sodas"><FormattedMessage id="sodas"/></label>
        <select className="form-control" id="sodas" onChange={props.sodasChange} value={props.sodasNumber}>
            <option value="null"><FormattedMessage id="no-answer"/></option>
            {props.sodasOptions}
        </select>
    </div>)


    let fast_food = (<div className="form-group">
        <label htmlFor="fast_food"><FormattedMessage id="fast-food"/></label>
        <select className="form-control" id="fast_food" onChange={props.fastFoodChange} value={props.fastFoodNumber}>
            <option value="null"><FormattedMessage id="no-answer"/></option>
            {props.fastFoodOptions}
        </select>
    </div>)


    let alcohol = (<div className="form-group">
        <label htmlFor="alcohol"><FormattedMessage id="alcohol-edit"/></label>
        <select className="form-control" id="alcohol" onChange={props.alcoholChange} selected={props.selectedAlcohol}
                value={props.alcoholNumber}>
            <option value="null"><FormattedMessage id="no-answer"/></option>
            <option value="0"><FormattedMessage id="no"/></option>
            <option value="1"><FormattedMessage id="yes"/></option>
        </select>
    </div>)

    let beer_wine_spirit = null;
    if (props.alcoholNumber === 1) {
        beer_wine_spirit = (
            <Aux>
                <div className="form-group">
                    <label htmlFor="beer"><FormattedMessage id="beers"/></label>
                    <input type="number" step="1" min="0" id="beer" onChange={props.beerChange}
                           value={props.beerNumber}/>
                </div>
                <div className="form-group">
                    <label htmlFor="wine"><FormattedMessage id="wine"/></label>
                    <input type="number" step="1" min="0" id="wine" onChange={props.wineChange}
                           value={props.wineNumber}/>
                </div>
                <div className="form-group">
                    <label htmlFor="spirit_drinks"><FormattedMessage id="spirit_drinks"/></label>
                    <input type="number" step="1" min="0" id="spirit_drinks" onChange={props.spiritDrinksChange}
                           value={props.spiritDrinksNumber}/>
                </div>
            </Aux>
        )
    }


    if (props.selectedAlcohol === "1") {
        beer_wine_spirit = (
            <Aux>
                <div className="form-group">
                    <label htmlFor="beer"><FormattedMessage id="beers"/></label>
                    <input type="number" step="1" min="0" id="beer" onChange={props.beerChange}
                           value={props.beerNumber}/>
                </div>
                <div className="form-group">
                    <label htmlFor="wine"><FormattedMessage id="wine"/></label>
                    <input type="number" step="1" min="0" id="wine" onChange={props.wineChange}
                           value={props.wineNumber}/>
                </div>
                <div className="form-group">
                    <label htmlFor="spirit_drinks"><FormattedMessage id="spirit_drinks"/></label>
                    <input type="number" step="1" min="0" id="spirit_drinks" onChange={props.spiritDrinksChange}
                           value={props.spiritDrinksNumber}/>
                </div>
            </Aux>
        )
    }
    ;

    let physical_activity = (<div className="form-group">
        <label htmlFor="physical_activity"><FormattedMessage id="practice-physical"/></label>
        <select className="form-control" id="physical_activity" onChange={props.physicalChange}
                selected={props.selectedPhysical} value={props.physicalActivityNumber}>
            <option value="null"><FormattedMessage id="no-answer"/></option>
            <option value="0"><FormattedMessage id="no"/></option>
            <option value="1"><FormattedMessage id="yes"/></option>
        </select>
    </div>)


    let physical_values_hours = null;
    if (props.physicalActivityNumber == 1) {
        physical_values_hours = (
            <Aux>
                <div className="form-group">
                    <label htmlFor="physical_values"><FormattedMessage id="physical-name-edit"/></label>
                    <select className="form-control" id="physical_values" onChange={props.physicalValuesChange}
                            value={props.physicalValuesNumber}>
                        <option value="null"><FormattedMessage id="no-answer"/></option>
                        {props.physicalValuesOptions}
                    </select>
                </div>
                <div className="form-group">
                    <label htmlFor="physical_hours"><FormattedMessage id="physical-hours-edit"/></label>
                    <select className="form-control" id="physical_hours" onChange={props.physicalHoursChange}
                            value={props.physicalHoursNumber}>
                        <option value="null"><FormattedMessage id="no-answer"/></option>
                        {props.physicalHoursOptions}
                    </select>
                </div>
            </Aux>
        )
    }
    ;

    let walking_cycling = (<div className="form-group">
        <label htmlFor="walking_cycling"><FormattedMessage id="walking-cycling"/></label>
        <select className="form-control" id="walking_cycling" onChange={props.walkingCyclingChange}
                value={props.walkingCyclingNumber}>
            <option value="null"><FormattedMessage id="no-answer"/></option>
            {props.walkingCyclingOptions}
        </select>
    </div>)

    let systolic = (<div className="form-group">
        <label htmlFor="systolic">Pressão arterial sistólica</label>
        <input type="text" id="systolic" onChange={props.systolicChange} value={props.systolicNumber}/>
    </div>);

    let diastolic = (<div className="form-group">
        <label htmlFor="diastolic">Pressão arterial diastólica</label>
        <input type="text" id="diastolic" onChange={props.diastolicChange} value={props.diastolicNumber}/>
    </div>);

    let pulse = (<div className="form-group">
        <label htmlFor="pulse">Pulso</label>
        <input type="text" id="pulse" onChange={props.pulseChange} value={props.pulseNumber}/>
    </div>);

    let uricAcid = (<div className="form-group">
        <label htmlFor="uricAcid">Ácido úrico</label>
        <input type="text" id="uricAcid" onChange={props.uricAcidChange} value={props.uricAcidNumber}/>
    </div>);

    let glucose = (<div className="form-group">
        <label htmlFor="glucose">Glicose</label>
        <input type="text" id="glucose" onChange={props.glucoseChange} value={props.glucoseNumber}/>
    </div>);

    let cholesterol = (<div className="form-group">
        <label htmlFor="cholesterol">Colesterol total</label>
        <input type="text" id="cholesterol" onChange={props.cholesterolChange} value={props.cholesterolNumber}/>
    </div>);


    let spirometry = (<div className="form-group">
        <label htmlFor="spiro">Espirometria</label>
        <select className="form-control" id="spiro" onChange={props.spiroChange} value={props.spirometryNumber}>
            <option value="0"><FormattedMessage id="no"/></option>
            <option value="1"><FormattedMessage id="yes"/></option>
        </select>
    </div>)

    let spiro = null;
    if (props.spirometryNumber == 1) {
        spiro = (<div className="form-group">
                <label htmlFor="spirochange">Alteração</label>
                <select className="form-control" id="spirochange" onChange={props.spiroSelected}
                        value={props.spirometryChangeNumber}>
                    <option value="null"><FormattedMessage id="no-answer"/></option>
                    {props.spiroSelect}
                </select>
            </div>
        )
    }

    let visualScreening = (<div className="form-group">
        <label htmlFor="visualscreening">Rastreio Visual</label>
        <select className="form-control" id="visualscreening" onChange={props.visualChange} value={props.visualNumber}>
            <option value="0"><FormattedMessage id="no"/></option>
            <option value="1"><FormattedMessage id="yes"/></option>
        </select>
    </div>);

    let visual = null;
    if (props.visualNumber == 1) {
        visual = (<div className="form-group">
            <label htmlFor="visualchange">Alteração</label>
            <select className="form-control" id="visualchange" onChange={props.visualSelected}
                    value={props.visualChangeNumber}>
                <option value="null"><FormattedMessage id="no-answer"/></option>
                {props.visualSelect}
            </select>
        </div>)
    }

    let auditoryScreening = (<div className="form-group">
        <label htmlFor="auditoryscreening">Rastreio Auditivo</label>
        <select className="form-control" id="auditoryscreening" onChange={props.auditoryChange} value={props.auditoryNumber}>
            <option value="0"><FormattedMessage id="no"/></option>
            <option value="1"><FormattedMessage id="yes"/></option>
        </select>
    </div>);

    let auditory = null;
    if (props.auditoryNumber == 1) {
        auditory = (<div className="form-group">
            <label htmlFor="auditorychange">Alteração</label>
            <select className="form-control" id="auditorychange" onChange={props.auditorySelected}
                    value={props.auditoryChangeNumber}>
                <option value="null"><FormattedMessage id="no-answer"/></option>
                {props.auditorySelect}
            </select>
        </div>)
    }

    let ecg= (<div className="form-group">
        <label htmlFor="ecg">ECG</label>
        <select className="form-control" id="ecg" onChange={props.ecgChange} value={props.ecgNumber}>
            <option value="0"><FormattedMessage id="no"/></option>
            <option value="1"><FormattedMessage id="yes"/></option>
        </select>
    </div>);

    let ecgOptions = null;
    if (props.ecgNumber == 1) {
        ecgOptions = (<div className="form-group">
            <label htmlFor="ecgchange">Alteração</label>
            <select className="form-control" id="ecgchange" onChange={props.ecgSelected}
                    value={props.ecgChangeNumber}>
                <option value="null"><FormattedMessage id="no-answer"/></option>
                {props.ecgSelect}
            </select>
        </div>)
    }

    let eritrogram= (<div className="form-group">
        <label htmlFor="eritrogram">Eritograma</label>
        <select className="form-control" id="eritrogram" onChange={props.eritrogramChange} value={props.eritrogramNumber}>
            <option value="0"><FormattedMessage id="no"/></option>
            <option value="1"><FormattedMessage id="yes"/></option>
        </select>
    </div>);

    let eritrogramOptions = null;
    if (props.eritrogramNumber == 1) {
        eritrogramOptions = (<div className="form-group">
            <label htmlFor="eritrogramchange">Alteração</label>
            <select className="form-control" id="eritrogramchange" onChange={props.eritrogramSelected}
                    value={props.eritrogramChangeNumber}>
                <option value="null"><FormattedMessage id="no-answer"/></option>
                {props.eritrogramSelect}
            </select>
        </div>)
    }

    let leukogram= (<div className="form-group">
        <label htmlFor="leukogram">Leucograma</label>
        <select className="form-control" id="leukogram" onChange={props.leukogramChange} value={props.leukogramNumber}>
            <option value="0"><FormattedMessage id="no"/></option>
            <option value="1"><FormattedMessage id="yes"/></option>
        </select>
    </div>);

    let leukogramOptions = null;
    if (props.leukogramNumber == 1) {
        leukogramOptions = (<div className="form-group">
            <label htmlFor="leukogramchange">Alteração</label>
            <select className="form-control" id="leukogramchange" onChange={props.leukogramSelected}
                    value={props.leukogramChangeNumber}>
                <option value="null"><FormattedMessage id="no-answer"/></option>
                {props.leukogramSelect}
            </select>
        </div>)
    }


    return (
        <div className="container col-12 mt-8">
            <h3 className="text-secondary mb-3"><FormattedMessage id="edit-form"/></h3>
            <hr/>
            <h6 className="text-primary font-weight-normal">Dados sócio-demográficos</h6>
            {gender}
            {department}
            {age}
            {marital_status}
            {academic_levels}

            <h6 className="text-primary font-weight-normal">Hábitos tabágicos e de saúde</h6>
            {smoking_status}
            {regularity_number}
            {health_opinion}
            {weight}
            {height}

            <h4 className="text-primary font-weight-normal">Doença e dor</h4>
            {has_chronic}

                {chronic}
                {chronicValues}
            {takes_meds}
            {meds_number_values}
            {pain_value}
            {pain_local_scale}

            <h6 className="text-primary font-weight-normal">Hábitos alimentares</h6>
            {meals}
            {breakfast}
            {fruit}
            {vegetables}
            {sodas}
            {fast_food}
            {alcohol}
            {beer_wine_spirit}

            <h6 className="text-primary font-weight-normal">Exercício físico</h6>
            {physical_activity}
            {physical_values_hours}
            {walking_cycling}


            <h6 className="text-primary font-weight-normal">Exames de diagnóstico</h6>
            {systolic}
            {diastolic}
            {pulse}
            {uricAcid}
            {glucose}
            {cholesterol}

            {spirometry}
            {spiro}
            {visualScreening}
            {visual}
            {auditoryScreening}
            {auditory}
            {ecg}
            {ecgOptions}
            {eritrogram}
            {eritrogramOptions}
            {leukogram}
            {leukogramOptions}

        </div>
    )
};

export default editForm;



// WEBPACK FOOTER //
// ./src/components/EditForm.js